import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "@/App";
// Inter, served with the app: the font stack names it first, and a computer without it installed drew
// the console in whatever sans-serif it had (ACL-590).
import "@fontsource-variable/inter";
import "@/index.css";

const root = document.getElementById("root");
if (!root) throw new Error("#root missing from index.html");
createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
